export default "__VITE_ASSET__ee38ec06__"